import React from "react";
import TeacherPortalLearningMaterialRow from "./LearningMaterialRow";
import SortingBoldTableCell from "../../general/table/SortingBoldTableCell";

const TeacherPortalLearningMaterialTable = ({ activitiesWithUsageData }) => {
    const [active, setActive] = React.useState('activitytype');
    const [direction, setDirection] = React.useState('asc');

    activitiesWithUsageData = activitiesWithUsageData.map((item) => {
        const firstTimestamp = item.use_data && item.use_data.length > 0 && item.use_data[0].timestamp ? item.use_data[0].timestamp : undefined;
        const lastTimestamp = item.use_data && item.use_data.length > 0 && item.use_data[item.use_data.length - 1].timestamp ? item.use_data[item.use_data.length - 1].timestamp : undefined;
        item.first_accessed = firstTimestamp;
        item.last_accessed = lastTimestamp;
        return item;
    });

    const activitiesWithUsageDataSorted = () => activitiesWithUsageData.sort((a, b) => {
        let aValue;
        let bValue;
        if (active === 'activitytype') { aValue = a.activitytype.toLowerCase(); bValue = b.activitytype.toLowerCase(); }
        else if (active === 'activitytitle') { aValue = a.activitytitle.toLowerCase(); bValue = b.activitytitle.toLowerCase(); }
        else if (active === 'first_accessed') { aValue = a.first_accessed ? new Date(a.first_accessed) : new Date(0); bValue = b.first_accessed ? new Date(b.first_accessed) : new Date(0); }
        else if (active === 'last_accessed') { aValue = a.last_accessed ? new Date(a.last_accessed) : new Date(0); bValue = b.last_accessed ? new Date(b.last_accessed) : new Date(0); }
        else if (active === 'count_usage_data') { aValue = a.total_usage_data.count_events; bValue = b.total_usage_data.count_events; }
        else if (active === 'count_users') { aValue = a.total_usage_data.count_users; bValue = b.total_usage_data.count_users; }
        else if (active === 'count_users_last_30_days') { aValue = a.total_usage_data.count_users_last_30_days; bValue = b.total_usage_data.count_users_last_30_days; }
        if (direction === 'asc') return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    });

    const headerProps = { active, setActive, setDirection, direction };
    return <div className="overflow-x-auto rounded bg-white shadow-default">
        <table className="w-full min-w-[650px] border-separate border-spacing-0" aria-label="simple table">
            <thead><tr>
                <SortingBoldTableCell {...headerProps} name="activitytype">Activity Type</SortingBoldTableCell>
                <SortingBoldTableCell {...headerProps} name="activitytitle">Activity Title</SortingBoldTableCell>
                <SortingBoldTableCell {...headerProps} name="first_accessed">First Accessed</SortingBoldTableCell>
                <SortingBoldTableCell {...headerProps} name="last_accessed">Last Accessed</SortingBoldTableCell>
                <SortingBoldTableCell {...headerProps} name="count_usage_data">Amount of actions</SortingBoldTableCell>
                <SortingBoldTableCell {...headerProps} name="count_users">Total users</SortingBoldTableCell>
                <SortingBoldTableCell {...headerProps} name="count_users_last_30_days">Users in last 30 days</SortingBoldTableCell>
            </tr></thead>
            <tbody>{activitiesWithUsageDataSorted().map((item) => <TeacherPortalLearningMaterialRow key={item.activityid} activityWithUsageData={item} />)}</tbody>
        </table>
    </div>;
}

export default TeacherPortalLearningMaterialTable;
